/**
  © BlockyApps. You are permitted to use this content within your store. Redistribution or use in any other application is strictly prohibited. 
  Unauthorized copying, distribution, or reproduction in any form will result in legal action.
**/

document.querySelectorAll(".blocky-pdr-slider-auto-old").forEach(t=>{
  if (t.hasAttribute("data-click")) return
  t.setAttribute('data-click', "")
  setInterval(function(){
    const pdr = t.closest(".blocky-pdr")
    const container = pdr.querySelector(".blocky-pdr-container")

    const hasFirst = pdr.querySelector(`[data-index="0"]`)
    const hasSecond = pdr.querySelector(`[data-index="1"]`)
    const hasThird = pdr.querySelector(`[data-index="2"]`)
    let size = 0
    if (hasFirst) size += 1
    if (hasSecond) size += 1
    if (hasThird) size += 1

    if (size <= 1) return

    // Switch the background
    const active = pdr.querySelector(".blocky-pdr-container-text-active") || pdr.querySelector(`[data-index="0"]`) || pdr.querySelector(`[data-index="1"]`) || pdr.querySelector(`[data-index="2"]`)
    const curr = parseInt(active.getAttribute("data-index"))
    const newPos = curr < 2 ? curr + 1 : 0

    // Check if review 1/2/3 is missing
    let pos = newPos
    if (pos === 2) {
        if (!hasThird) {
            if (!hasFirst) {
                pos = 1
            } else {
                pos = 0
            }    
        }
    } else if (pos === 1) {
        if (!hasSecond) {
            if (!hasThird) {
                pos = 0
            } else {
                pos = 2
            }    
        }  
    } else if (pos === 0) {
        if (!hasFirst) {
            if (!hasSecond) {
                pos = 2
            } else {
                pos = 1
            }    
        }  
    }

    active.classList.remove("blocky-pdr-container-text-active")
    pdr.querySelector(`[data-index="${pos}"]`).classList.add("blocky-pdr-container-text-active")

    let windowPos = pos
    if (windowPos === 2) {
        windowPos = size - 1
    } else if (windowPos === 1) {
        if (!hasFirst) windowPos = 0
    }
  
    // Scrolling
    let e = container.clientWidth * windowPos;
    container.scrollTo({
        left: e
    })
  }, 5000);
})

document.querySelectorAll(".blocky-pdr-carot-old").forEach(c=>{
  if (c.hasAttribute("data-click")) return
  c.setAttribute('data-click', "")
  c.addEventListener("click", (event) => {
    event.preventDefault();
    const pdr = c.closest(".blocky-pdr")
    const container = pdr.querySelector(".blocky-pdr-container")

    const hasFirst = pdr.querySelector(`[data-index="0"]`)
    const hasSecond = pdr.querySelector(`[data-index="1"]`)
    const hasThird = pdr.querySelector(`[data-index="2"]`)
    let size = 0
    if (hasFirst) size += 1
    if (hasSecond) size += 1
    if (hasThird) size += 1

    if (size <= 1) return

    // Switch the background
    const active = pdr.querySelector(".blocky-pdr-container-text-active") || pdr.querySelector(`[data-index="0"]`) || pdr.querySelector(`[data-index="1"]`) || pdr.querySelector(`[data-index="2"]`)
    const curr = parseInt(active.getAttribute("data-index"))
    const isForward = c.getAttribute("name") === 'next'
    let newPos = isForward ? parseInt(curr) + 1 : parseInt(curr) - 1

    if (newPos < 0) newPos = 2
    if (newPos > 2) newPos = 0

    // Check if review 1/2/3 is missing
    let pos = newPos
    if (pos === 2) {
        if (!hasThird) {
            if (isForward) {
                pos = 0
            } else {
                pos = 1
            }    
        }
    } else if (pos === 1) {
        if (!hasSecond) {
            if (isForward) {
                pos = 2
            } else {
                pos = 0
            }    
        }  
    } else if (pos === 0) {
        if (!hasFirst) {
            if (isForward) {
                pos = 1
            } else {
                pos = 2
            }    
        }  
    }

    active.classList.remove("blocky-pdr-container-text-active")
    pdr.querySelector(`[data-index="${pos}"]`).classList.add("blocky-pdr-container-text-active")

    let windowPos = pos
    if (windowPos === 2) {
        windowPos = size - 1
    } else if (windowPos === 1) {
        if (!hasFirst) windowPos = 0
    }

    // Scrolling
    let e = container.clientWidth * windowPos;
    container.scrollTo({
        left: e
    })
  })
})